import * as types from './types';
import { Event } from '@interfaces/outreach-entity';
import ListResponse from '@interfaces/list-response';
import { YearsFilter } from '@interfaces/years-filter';
import { RequestState } from '@interfaces/request-state';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';

export interface EventsPageState extends RequestState {
    readonly list: ListResponse<Event>;
    readonly listParams: OutreachRequestParams;
    readonly filters: YearsFilter & RequestState;
}

const initialState: EventsPageState = {
    list: {
        rows: [],
        meta: {}
    },
    listParams: {},
    filters: {
        years: [],
        isLoading: false,
        error: undefined
    },
    isLoading: false,
    error: undefined
};

/* tslint:disable-next-line cyclomatic-complexity */
function reducer(state = initialState, action: any): EventsPageState {
    switch (action.type) {
        case types.FETCH_EVENTS_PAGE:
            return fetchEvents(state, action);

        case types.FETCH_EVENTS_PAGE_SUCCESS:
            return fetchEventsSuccess(state, action);

        case types.FETCH_EVENTS_PAGE_ERROR:
            return fetchEventsError(state, action);

        case types.FETCH_EVENTS_FILTERS:
            return fetchEventsFilters(state);

        case types.FETCH_EVENTS_FILTERS_SUCCESS:
            return fetchEventsFiltersSuccess(state, action);

        case types.FETCH_EVENTS_FILTERS_ERROR:
            return fetchEventsFiltersError(state, action);

        default:
            return state;
    }
}

function fetchEvents(state: EventsPageState, action: any) {
    const { page = 1 } = action.payload || {};

    const list = {
        ...state.list,
        rows: page === 1 ? [] : state.list.rows
    };

    return {
        ...state,
        list,
        isLoading: true,
        error: undefined
    };
}

function fetchEventsSuccess(state: EventsPageState, action: any) {
    const { data, params } = action.payload;
    const { meta, rows: actionRows } = data;
    const rows = meta.pageNumber === 1 ? actionRows : [...state.list.rows, ...actionRows];

    return {
        ...state,
        list: { meta, rows },
        listParams: params,
        isLoading: false,
        error: undefined
    };
}

function fetchEventsError(state: EventsPageState, action: any) {
    return {
        ...state,
        isLoading: false,
        error: action.payload
    };
}

function fetchEventsFilters(state: EventsPageState) {
    return {
        ...state,
        filters: {
            ...state.filters,
            isLoading: true,
            error: undefined
        }
    };
}

function fetchEventsFiltersSuccess(state: EventsPageState, action: any) {
    const { years } = action.payload;

    return {
        ...state,
        filters: {
            ...state.filters,
            isLoading: false,
            years
        }
    };
}

function fetchEventsFiltersError(state: EventsPageState, action: any) {
    return {
        ...state,
        filters: {
            ...state.filters,
            isLoading: false,
            error: action.payload
        }
    };
}

export default reducer;
